var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKwMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28894 7.31971C2.49754 7.07319 2.74406 6.75081 2.95266 6.48532L5.09551 3.98216H6.66947L3.88186 6.97837L7.0677 11.2451H5.45582L2.97162 7.75587L2.28894 8.5144V11.2451H0.980469V0.606689H2.28894V7.31971Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73656 4.00139L9.70369 7.68027C9.91229 8.4957 10.1019 9.25423 10.2347 9.9938C10.4243 9.25423 10.6708 8.47673 10.9173 7.68027L12.0931 3.98242H13.2119L14.3497 7.60442C14.6152 8.45777 14.8238 9.23527 14.9945 9.97484C15.1651 9.23527 15.3548 8.47673 15.6013 7.62338L16.6443 3.98242H17.9527L15.5823 11.2454H14.3876L13.2878 7.77509C13.0223 6.95967 12.8137 6.23906 12.643 5.38571C12.4344 6.25802 12.2069 7.01656 11.9414 7.79405L10.7846 11.2454H9.57095L7.39017 4.00139H8.73656Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4555 0V15H19.4505V0H20.4555Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8447 0.606689H24.1531V5.11996C24.3997 4.7407 24.7221 4.41832 25.1392 4.19076C25.5185 3.9632 25.9926 3.83046 26.4856 3.83046C27.4717 3.83046 29.0078 4.41832 29.0078 6.92148V11.2451H27.7183V7.07319C27.7183 5.89746 27.2821 4.91137 26.0495 4.91137C25.1772 4.91137 24.5135 5.51819 24.2669 6.21984C24.1911 6.40947 24.1721 6.5991 24.1721 6.84563V11.2262H22.8636V0.606689H22.8447Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKwMeasure);
export default __webpack_public_path__ + "static/media/kwMeasure.d97ee304d042e7ea572556a1ed010fd8.svg";
export { ForwardRef as ReactComponent };